<template>
  <div>
    <div class="mx-0 mx-sm-4">
      <v-fade-transition>
        <div v-if="loading"><loading :message="title"></loading></div>
        <div v-else-if="error">Error loading data</div>
        <v-alert v-else-if="dataLoaded && noCodes" type="warning" class="my-3">
          Sorry, I did not find any codes when searching for '{{ search }}'
        </v-alert>
        <div v-else-if="codes && meta">
          <icd-header :simple="true" :title="title" noBreadcrumbs></icd-header>

          <div class="mb-6" v-if="counts.favorites">
            <div class="overline">Possible Eye-Related Results</div>

            <div v-for="(codeObj, code) in sortedCodes.favorites" :key="code">
              <a
                :href="'/icd10/' + code"
                class="link mb-2 d-sm-flex flex-sm-row align-center"
              >
                <div class="title codeWidth mr-2">{{ code }}</div>
                <div>
                  {{ codeObj.name }}
                </div>
              </a>
            </div>
          </div>
          <div>
            <div
              v-if="counts.favorites && counts.nonfavorites"
              class="overline"
            >
              The rest
            </div>
          </div>
          <div v-for="(codeObj, code) in sortedCodes.nonfavorites" :key="code">
            <a
              :href="'/icd10/' + code"
              class="link mb-2 d-sm-flex flex-sm-row align-center"
            >
              <div class="title codeWidth mr-2">{{ code }}</div>
              <div>
                {{ codeObj.name }}
              </div>
            </a>
          </div>
        </div>
      </v-fade-transition>
    </div>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
// import IcdHeader from "./IcdHeader.vue";
import IcdObjectMixin from "@/assets/js/icd/IcdObjectMixin";
// import IcdItem from "./icdItem.vue";

export default {
  name: "IcdSearchAll",
  components: {
    // IcdTreeElement: () => import("@/components/icdStuff/IcdTreeElement"),
    Loading: () => import("@/components/universalStuff/Loading.vue"),
    // IcdItem: () => import("@/components/icdStuff/IcdItem.vue"),
    IcdHeader: () => import("@/components/icdStuff/IcdHeader.vue"),
  },
  mixins: [IcdObjectMixin],
  props: {},
  data: function () {
    return {
      search: null,
      loading: false,
      title: null,
      codes: null,
      error: false,
      meta: null,
      dataLoaded: false,
    };
  },
  computed: {
    counts: function () {
      let counts = { favorites: 0, nonfavorites: 0, total: 0 };
      if (this.sortedCodes)
        counts.favorites = Object.keys(this.sortedCodes.favorites).length;
      if (this.sortedCodes)
        counts.nonfavorites = Object.keys(this.sortedCodes.nonfavorites).length;
      if (this.sortedCodes)
        counts.total = counts.favorites + counts.nonfavorites;
      return counts;
    },
    sortedCodes: function () {
      if (!this.codes) return null;
      let favorites = [];
      if (this.meta?.favorites) favorites = this.meta.favorites;
      let favObj = {};
      let theRestObj = {};
      let allCodes = Object.keys(this.codes);
      for (const code of allCodes) {
        let codeObj = this.codes[code];
        if (favorites.includes(code)) {
          favObj[code] = codeObj;
        } else {
          theRestObj[code] = codeObj;
        }
      }
      return { favorites: favObj, nonfavorites: theRestObj };
    },
    noCodes: function () {
      if (!this.codes) return true;
      let allCodes = Object.keys(this.codes);
      return !allCodes || !allCodes.length;
    },
  },
  methods: {
    // codeClicked(code) {
    //   this.$router.push({ path: `/icd10/${code}` });
    // },

    callApi() {
      this.loading = true;
      ApiServices.genericApiCall("/icd/deepSearch/" + this.search)
        .then((response) => {
          this.codes = response.data.results;
          this.meta = response.data.meta;
          this.loading = false;
          this.error = false;
          let title = response.data?.meta["title"];
          if (title) this.title = title;
          this.dataLoaded = true;
        })
        .catch((error) => {
          console.log(error);
          // this.error = true;
          this.loading = false;
        });
    },
  },

  mounted: function () {
    if (this.$route.params.search) this.search = this.$route.params.search;
    if (this.$route.query.q)
      this.search = decodeURIComponent(this.$route.query.q);
    if (this.search) {
      this.title = `Searching for codes matching '${this.search}'`;
      this.callApi();
    }
  },
  metaInfo() {
    return {
      title: `EyeDock/ICD10 | ${this.search}`,
    };
  },
};
</script>

<style scoped>
.link {
  cursor: pointer;
  color: #1976d2;
  text-decoration: none;
}
.codeWidth {
  width: 95px;
  /* text-align: right; */
}
</style>
